



















import { Component, Vue } from "vue-property-decorator";

@Component
class ModalMixinLoginRequire extends Vue {
  get modal() {
    const currentPageNeedAuth = this.$store.state.app.currentPageNeedAuth;
    return currentPageNeedAuth && this.$store.state.app.mixinLoginOutDate;
  }

  handleAuth() {
    this.$common.utils.helper.requestMixinLogin(this);
  }
}
export default ModalMixinLoginRequire;
